<div class="change-row">
  @if (hasBase) {
  <cs-segment class="direction-switch" [selection]="direction" (selectionChange)="onDirectionPicked($event)">
    <cs-segment-button [value]="CalorieChangeDirection.Decrease">
      {{ LL.calorieChange.decrease() }}
    </cs-segment-button>
    <cs-segment-button [value]="CalorieChangeDirection.Increase">
      {{ LL.calorieChange.increase() }}
    </cs-segment-button>
  </cs-segment>
  }
  <div class="fields">
    @if (hasBase) {
    <cs-input-measure #percentInput class="percent-field" type="percent" [precisionOverride]="0.1"
      [canonValue]="percent" (canonValueChange)="onPercentEdited($event)"></cs-input-measure>
    <span class="equals" aria-hidden="true">{{ equalsSign }}</span>
    }
    <cs-input-measure #kcalInput class="kcal-field" type="nutrient_kcal"
      [canonValue]="kcal" (canonValueChange)="onKcalEdited($event)"></cs-input-measure>
  </div>
</div>
@if (helperText) {
<cs-note light class="helper">{{ helperText }}</cs-note>
}
@if (belowMinimumText) {
<cs-info-card type="warning" [dismissible]="false" [message]="belowMinimumText"></cs-info-card>
}
